import CryptoJS from 'crypto-js';

// Generiere einen einzigartigen Schlüssel basierend auf Browser-Eigenschaften
const generateBrowserKey = () => {
  const browserInfo = [
    navigator.userAgent,
    navigator.language,
    window.screen.width,
    window.screen.height,
    new Date().toDateString() // Ändert sich täglich für zusätzliche Sicherheit
  ].join('|');
  
  return CryptoJS.SHA256(browserInfo).toString();
};

// Verschlüsselte Speicherung
export const secureStorage = {
  // Token sicher speichern
  setToken: (token) => {
    if (!token) {
      localStorage.removeItem('auth_data');
      return;
    }
    
    try {
      const key = generateBrowserKey();
      const encrypted = CryptoJS.AES.encrypt(token, key).toString();
      
      // Zusätzliche Obfuskierung: Speichere in mehreren Teilen
      const parts = encrypted.match(/.{1,20}/g) || [];
      const storage = {
        p1: parts[0] || '',
        p2: parts[1] || '',
        p3: parts[2] || '',
        remainder: parts.slice(3).join(''),
        timestamp: Date.now()
      };
      
      localStorage.setItem('auth_data', JSON.stringify(storage));
      console.log('🔐 Token sicher verschlüsselt und gespeichert');
    } catch (error) {
      console.error('❌ Fehler bei Token-Verschlüsselung:', error);
      // Fallback: Normale Speicherung
      localStorage.setItem('token', token);
    }
  },

  // Token sicher abrufen
  getToken: () => {
    try {
      const authData = localStorage.getItem('auth_data');
      if (!authData) {
        // Fallback: Prüfe alte token-Speicherung
        return localStorage.getItem('token');
      }
      
      const storage = JSON.parse(authData);
      
      // Prüfe Zeitstempel (Token automatisch löschen nach 25 Stunden)
      const maxAge = 25 * 60 * 60 * 1000; // 25 Stunden
      if (Date.now() - storage.timestamp > maxAge) {
        console.log('🔐 Verschlüsseltes Token abgelaufen');
        secureStorage.clearToken();
        return null;
      }
      
      // Rekonstruiere verschlüsselten String
      const encrypted = storage.p1 + storage.p2 + storage.p3 + storage.remainder;
      
      const key = generateBrowserKey();
      const decrypted = CryptoJS.AES.decrypt(encrypted, key);
      const token = decrypted.toString(CryptoJS.enc.Utf8);
      
      if (!token) {
        console.log('🔐 Token-Entschlüsselung fehlgeschlagen');
        secureStorage.clearToken();
        return null;
      }
      
      return token;
    } catch (error) {
      console.error('❌ Fehler bei Token-Entschlüsselung:', error);
      // Fallback bei Entschlüsselungsfehlern
      secureStorage.clearToken();
      return localStorage.getItem('token');
    }
  },

  // Token sicher löschen
  clearToken: () => {
    localStorage.removeItem('auth_data');
    localStorage.removeItem('token'); // Auch alte Speicherung löschen
    localStorage.removeItem('user');
    console.log('🔐 Alle Token-Daten gelöscht');
  },

  // User-Daten verschlüsselt speichern
  setUserData: (userData) => {
    if (!userData) {
      localStorage.removeItem('user_data');
      return;
    }
    
    try {
      const key = generateBrowserKey();
      const userJson = JSON.stringify(userData);
      const encrypted = CryptoJS.AES.encrypt(userJson, key).toString();
      
      localStorage.setItem('user_data', encrypted);
      console.log('🔐 User-Daten sicher verschlüsselt');
    } catch (error) {
      console.error('❌ Fehler bei User-Daten-Verschlüsselung:', error);
      // Fallback
      localStorage.setItem('user', JSON.stringify(userData));
    }
  },

  // User-Daten sicher abrufen
  getUserData: () => {
    try {
      const encrypted = localStorage.getItem('user_data');
      if (!encrypted) {
        // Fallback
        const userData = localStorage.getItem('user');
        return userData ? JSON.parse(userData) : null;
      }
      
      const key = generateBrowserKey();
      const decrypted = CryptoJS.AES.decrypt(encrypted, key);
      const userJson = decrypted.toString(CryptoJS.enc.Utf8);
      
      if (!userJson) {
        console.log('🔐 User-Daten-Entschlüsselung fehlgeschlagen');
        return null;
      }
      
      return JSON.parse(userJson);
    } catch (error) {
      console.error('❌ Fehler bei User-Daten-Entschlüsselung:', error);
      return null;
    }
  },

  // Prüfe Token-Gültigkeit (gleiche Logik wie in App.js)
  isTokenValid: (token) => {
    if (!token) return false;
    
    try {
      const parts = token.split('.');
      if (parts.length !== 3) return false;
      
      const payload = JSON.parse(atob(parts[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      
      if (payload.exp && payload.exp < currentTime) {
        console.log('🔐 Token ist abgelaufen:', new Date(payload.exp * 1000));
        return false;
      }
      
      return true;
    } catch (error) {
      console.error('🔐 Fehler beim Validieren des Tokens:', error);
      return false;
    }
  }
};

export default secureStorage;
